import { render } from "./MostBuyArticles.vue?vue&type=template&id=a3810bba"
import script from "./MostBuyArticles.vue?vue&type=script&lang=js"
export * from "./MostBuyArticles.vue?vue&type=script&lang=js"

import "./MostBuyArticles.vue?vue&type=style&index=0&id=a3810bba&lang=scss"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__